import { ticketServiceApi } from "../../../../app/superAdmin/ticketServiceApi";
import { API_URL } from "../../../../constants/apiUrl";
import { GetQueryArgsType } from "../../../../types";
import {
  AllFeatureResponse,
  AllFeaturesParams,
  FeatureDetailsResponse,
} from "./feature.types";

export const featureApi = ticketServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    // Queries
    getAllFeatures: builder.query<
      AllFeatureResponse,
      GetQueryArgsType<AllFeaturesParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllFeature,
        ...queryArgs,
      }),
      providesTags: ["GetAllFeatures"],
    }),

    getFeatureDetails: builder.query<FeatureDetailsResponse, any>({
      query: (id) => ({
        url: `${API_URL.getFeatureDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetAllFeatures", id }],
    }),

    // Mutations
    createFeature: builder.mutation({
      query: (data) => ({
        url: API_URL.createFeature,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["GetAllFeatures"],
    }),

    updateFeature: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateFeature}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        return [
          "GetAllFeatures",
          { type: "GetAllFeatures", id: result?.data?.id },
        ];
      },
    }),

    updateFeatureStatus: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateFeatureStatus}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        return [
          "GetAllFeatures",
          { type: "GetAllFeatures", id: result?.data?.id },
        ];
      },
    }),

    // deleteProduct: builder.mutation({
    //   query: ({ id }) => ({
    //     url: `${API_URL.deleteTicket}/${id}`,
    //     method: "DELETE",
    //   }),
    //   invalidatesTags: ["GetAllProducts"],
    // }),
  }),
});

export const {
  useGetAllFeaturesQuery,
  useGetFeatureDetailsQuery,
  useCreateFeatureMutation,
  useUpdateFeatureMutation,
  useUpdateFeatureStatusMutation,
} = featureApi;
